import Svg from 'components/utilities/svg'

const DiameterIcon = ({ ...props }) => (
  <Svg viewBox="0 0 9 11" {...props}>
    <title>Diameter Icon</title>
    <path d="M4.38304 9.07518C4.56454 9.10038 4.74993 9.11341 4.93836 9.11341C7.1475 9.11341 8.93836 7.32255 8.93836 5.11341C8.93836 4.1851 8.62213 3.33065 8.09152 2.65191L7.2996 4.02355C7.45285 4.35502 7.53836 4.72423 7.53836 5.11341C7.53836 6.46944 6.50026 7.58301 5.17542 7.70275L4.38304 9.07518Z" />
    <path d="M4.70122 2.52408C3.37642 2.64387 2.33836 3.75741 2.33836 5.11341C2.33836 5.50256 2.42386 5.87174 2.57708 6.20319L1.78515 7.57486C1.25457 6.89612 0.938362 6.04169 0.938362 5.11341C0.938362 2.90427 2.72922 1.11341 4.93836 1.11341C5.12677 1.11341 5.31213 1.12644 5.4936 1.15164L4.70122 2.52408Z" />
    <path d="M1.68187 9.56296C1.58621 9.50774 1.55344 9.38542 1.60867 9.28976L6.89036 0.141598C6.94559 0.0459397 7.06791 0.0131648 7.16357 0.0683933L8.19487 0.663815C8.29052 0.719044 8.3233 0.841362 8.26807 0.93702L2.98638 10.0852C2.93115 10.1808 2.80883 10.2136 2.71317 10.1584L1.68187 9.56296Z" />
  </Svg>
)

DiameterIcon.displayName = 'Diameter'

export default DiameterIcon
